import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from 'lodash';
import Checkbox from "../../../../../components/checkbox";
import {Collapse} from "react-collapse";

function DefensivePosition(props) {
    const {selected} = props;
    const [isOpened, setIsOpened] = useState(false);
    const [listDefensivePosition, listDefensivePositionHelper] = useList([
        {
            value: 1,
            name: '投手',
            checked: false,
        },
        {
            value: 2,
            name: '捕手',
            checked: false,
        },
        {
            value: 3,
            name: '一塁手',
            checked: false,
        },
        {
            value: 4,
            name: '二塁手',
            checked: false,
        },
        {
            value: 5,
            name: '三塁手',
            checked: false,
        },
        {
            value: 6,
            name: '遊撃手',
            checked: false,
        },
        {
            value: 7,
            name: '左翼手',
            checked: false,
        },
        {
            value: 8,
            name: '中堅手',
            checked: false,
        },
        {
            value: 9,
            name: '右翼手',
            checked: false,
        },
        {
            value: 10,
            name: '指名打者',
            checked: false,
        },
    ]);
    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = listDefensivePosition.findIndex(i => i.value === item);
            listDefensivePosition[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(listDefensivePosition,['checked', true]), 'value'));
    },[listDefensivePosition]);

    const onChange = (item, index) => {
      listDefensivePositionHelper.updateAt(index, {...item, checked: !item.checked});
    };

    return (
        <div className='inner-item-child group-filter-item'>
            <div className={'open-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>守備位置</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                </div>
                <Collapse isOpened={isOpened}>
                    <div className="search-group">
                        {listDefensivePosition.map((item, index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>
                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>守備位置</h4>
                </div>
                    <div className="search-group">
                        {listDefensivePosition.map((item, index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>
            </div>
        </div>
    )
}

export default DefensivePosition;
